import React from "react";
import { AuthProvider } from "../../../AuthContext.js";
import RutasDueno from "../rutas/RutasDueno.js";
import Header from "../../../componentes/layouts/Headers.js";
import Footer from "../../../componentes/layouts/Footer.js";
import "../../../static/css/appDueno.css";

const AppDueno = () => {
    return (
        <AuthProvider>
            <div className="d-flex flex-column min-vh-100 app-container">
                <Header className="header" />
                <div className="flex-grow-1">
                    <RutasDueno />
                </div>
                <Footer className="footer" />
            </div>
        </AuthProvider>
    );
};

export default AppDueno;

